var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch theme-input",attrs:{"dir":"rtl"}},_vm._l((_vm.values),function(item,i){return _c('button',{class:{ selected: item.value == _vm.value },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', item.value)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }